import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { InfoTooltip } from '../InfoTooltip'

export const WidgetHeaderContent = styled.div`
  flex: 1 0 56%;
  font-weight: bold;
  font-size: 1.2em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;

  @media only screen and (min-width: 768px) {
    flex: 1 0 60%;
  }
`

export const WidgetHeaderActions = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  padding: 2px;
  a {
    text-decoration: none;
  }
`

export const WidgetHeader = styled(({ actions, className, header, info }) => {
  if (!header && !actions) {
    return null
  }
  return (
    <div className={className}>
      {header && (
        <WidgetHeaderContent>
          {header}
          {info && <InfoTooltip mb='2px' info={info} />}
        </WidgetHeaderContent>
      )}
      {actions && (
        <WidgetHeaderActions>{actions}</WidgetHeaderActions>
      )}
    </div>
  )
})`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  line-height: 1.75;
  padding: 16px 16px 0;
  ${({ theme }) => theme.widget.header}
`

WidgetHeader.propTypes = {
  actions: PropTypes.node,
  header: PropTypes.node,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

WidgetHeader.defaultProps = {
  actions: null,
  header: null,
}

export default WidgetHeader
